<div class="d-flex justify-center align-items-center h-100">
  <div class="d-flex flex-column align-items-center">
    <div class="pb-2">
      <i class="icon-large fa-regular fa-credit-card"></i>
    </div>

    <p-progressBar *ngIf="showBar()" [style]="{height: '12px', width: '150px'}" mode="indeterminate"></p-progressBar>

    <ng-container *ngIf="paymentStatusSignal.value === 'NEW' || paymentStatusSignal.value === null">
      <ng-container *ngIf="showWarning()">
        <span class="pt-2">{{translationSchema['payment-method']['long-processing-warning'] | translate}}</span>
        <div class="d-flex mt-2 justify-center">
          <button (click)="onRetryPaymentClick()" pButton data-testid="on-retry-payment-click-btn">{{translationSchema['payment-method'].retry | translate}}</button>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="paymentStatusSignal.value === 'PENDING'">
      <span class="pt-2">{{translationSchema['payment-method']['pending-payment-method'] | translate}}</span>
      <div class="d-flex mt-2 justify-center">
        <button (click)="onRefreshClick()" class="mr-1" pButton data-testid="on-refresh-click-btn">{{translationSchema['payment-method'].refresh | translate}}</button>
        <button (click)="onRetryPaymentClick()" pButton data-testid="on-retry-payment-click-btn-2">{{translationSchema['payment-method']['change-payment-method'] | translate}}</button>
      </div>
    </ng-container>

    <ng-container *ngIf="paymentStatusSignal.value === 'FAILED'">
      <span class="pt-2">{{translationSchema['payment-method']['failed-payment-method'] | translate}}</span>
      <div class="d-flex mt-2 justify-center">
        <button (click)="onRetryPaymentClick()" pButton data-testid="on-retry-payment-click-btn-3">{{translationSchema['payment-method'].retry | translate}}</button>
      </div>
    </ng-container>

  </div>
</div>


